import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import '../App.scss';
/*import TagManager from 'react-gtm-module';*/
import { useState } from "react";

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'PaymentCompleted'
//    },
//    dataLayerName: 'PaymentCompletedPageDataLayer'
//}

export default function PaymentCompleted(props: any) {
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    let navigate = useNavigate();
    const [siteConfig, setSiteConfig] = useState(JSON.parse(localStorage.getItem('siteConfig') || "{}"))
    const formatPhone = (number: string) => number.replace(/^0/, '+44').replace(/\s+/g, '');
    /*TagManager.dataLayer(tagManagerArgs);*/

    localStorage.removeItem("paymentDetails");
    localStorage.removeItem("selectedQuote");
    localStorage.removeItem("quotes");
    localStorage.removeItem("customerDetails");
    localStorage.removeItem("questions");
    localStorage.removeItem("trade");
    localStorage.removeItem("status");
    localStorage.removeItem("gclid");
    localStorage.removeItem("deviceDetectionID");
    localStorage.removeItem("assumptions");
    localStorage.removeItem("realexCardID");
    localStorage.removeItem("payAnnual");
    localStorage.removeItem("browserType");
    localStorage.removeItem("deviceType");
    localStorage.removeItem("isMobile");

    const navigateToLogin = () => {
        if (localStorage.getItem('userData') === null) {
            navigate('/Login');
        } else {
            navigate('/YourAccount');
        }
    }

    return (
        <div className="pay-container App">
            <div className="notification-container">
                <span>
                    {siteConfig.activeSite === 'CAQ' ? (<>
                        <p>Thank you for arranging your Business Insurance with {siteConfig.tradingName},</p>
                        <p>your policy number is {localStorage.getItem("policyRef")}!</p>
                        <p>Your policy documents will be emailed to you shortly (please check your junk mail). This usually</p>
                        <p>only takes a few minutes, however, if you have not received them within the next hour please call</p>
                        <p>us on
                            <a className="header-phone-number-completed" href={`tel:${(formatPhone(siteConfig.phoneNumber))}`}>
                                &nbsp;{siteConfig.phoneNumber}.
                            </a>
                        </p>
                        <p>Thank you once again for choosing {siteConfig.tradingName}</p>

                        <button className="notification-button" onClick={() => navigateToLogin()}>My Account</button>

                        <div className="mt-70">

                            <h2 className="mt-11 mb-3">Can we help you with anything else?</h2>

                            <p className="mb-5">
                                We offer a range of other insurance products which can help protect your business.
                            </p>
                        </div>
                        <div className="row">
                            <div>
                                <a className="header-phone-number-completed underline" href={"https://www." + siteConfig.baseLinkUrl + "/insurance/tradesman-liability/"}><p><strong>Tradesman Liability</strong></p></a>
                            </div>
                            <div>
                                <a className="header-phone-number-completed underline" href={"https://www." + siteConfig.baseLinkUrl + "/insurance/contractors-all-risk/"}><p><strong>Contractors All Risk</strong></p></a>
                            </div>
                            <div>
                                <a className="header-phone-number-completed underline" href={"https://www." + siteConfig.baseLinkUrl + "/insurance/public-liability/landlord/"}><p><strong>Property Owners</strong></p></a>
                            </div>
                            <div>
                                <a className="header-phone-number-completed underline" href={"https://www." + siteConfig.baseLinkUrl + "/insurance/group-products/"}><p><strong>Group Products</strong></p></a>
                            </div>
                        </div>

                        <a href={siteConfig.baseLinkUrl + "/insurance/healthcare-plans/"} className="bottomBanner">Healthcare Plans for you and your employees starting from &#163;9pppm &#8211; click here to find out more</a>
                    </>) : (
                        <>
                            <p>Thank you for arranging your Business Insurance with {siteConfig.tradingName},</p>
                            <p>your policy number is {localStorage.getItem("policyRef")}!</p>
                            <p>Your policy documents will be emailed to you shortly (please check your junk mail). This usually</p>
                            <p>only takes a few minutes, however, if you have not received them within the next hour please call</p>
                            <p>us on
                                    <a className="header-phone-number-completed" href={`tel:${(formatPhone(siteConfig.phoneNumber))}`}>
                                    &nbsp;{siteConfig.phoneNumber}.
                                </a>
                            </p>
                            <p>Thank you once again for choosing {siteConfig.tradingName} insurance</p>
                            <button className="notification-button" onClick={() => navigateToLogin()}>My Account</button>

                        </>
                    )}
                </span>
            </div>
        </div>
    );
}